import Icon from 'veui/components/Icon'
import { IconEye } from 'dls-icons-vue'

Icon.register('eye', IconEye)
